/** @format */

import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonWidgetsModule } from '@dcsg-ngx-ecommerce/engage/component/common-widgets/common-widgets.module';
import { StripSpecialCharsPipe } from '@shared/utils/pipes';
import { CtaModule } from '../cta/cta.module';
import { SectionHeaderComponent } from './section-header.component';

@NgModule({
	imports: [CommonModule, CommonWidgetsModule, CtaModule, StripSpecialCharsPipe],
	declarations: [SectionHeaderComponent],
	bootstrap: [SectionHeaderComponent],
	exports: [SectionHeaderComponent],
	schemas: [NO_ERRORS_SCHEMA]
})
export class SectionHeaderModule {}
